<template lang="pug">
.container
  .card.marginTop.cardGeral
    .card-body
      div(class="card-header").titulo Pesquisar
      .searchPanel
          form(@submit.prevent="$emit('search', searchObject.simpleFieldValue)")
             .panel
              el-row.boxLabel(:gutter="20")
                el-col(:span="12")
                  p.label Assunto:
                  el-select.full-width(
                    v-model='searchObject.advancedObject.assunto',
                    placeholder='Selecione',
                    clearable,
                    @input="$emit('advancedInput', searchObject.advancedObject)"
                  )
                    el-option(
                      v-for='assunt in assuntos',
                      :key='assunt.codigo',
                      :label='assunt.descricao',
                      :value='assunt.codigo',
                      class="label-option"
                    )
                el-col.marginLeft(:span="8")
                  p.label Período de início da conversa:
                  el-row.flex
                    el-date-picker.input.full-width(
                      type="date",
                      name='firstInicioConversa'
                      v-model="searchObject.advancedObject.firstInicioConversa",
                      placeholder="Selecione",
                      format="dd/MM/yyyy",
                      v-mask="'##/##/#####'"
                    )
                    p.label.span até
                    el-date-picker.input.full-width(
                      type="date",
                      name='lastInicioConversa'
                      v-model="searchObject.advancedObject.lastInicioConversa",
                      placeholder="Selecione",
                      format="dd/MM/yyyy",
                      v-mask="'##/##/#####'"
                    )
              el-row.flex(:gutter="20")
                el-col.marginTop(:span="12")
                  p.label Status:
                  el-select.full-width(
                    v-model='searchObject.advancedObject.status',
                    placeholder='Selecione',
                    clearable,
                    @input="$emit('advancedInput', searchObject.advancedObject)"
                  )
                    el-option(
                      v-for='statu in status',
                      :key='statu.codigo',
                      :label='statu.descricao',
                      :value='statu.codigo',
                      class="label-option"
                    )
                el-col.marginTop.marginLeft(:span="8")
                  p.label Período da última resposta:
                  el-row.flex
                      el-date-picker.input.full-width(
                        type="date",
                        name='firstUltimaResposta'
                        v-model="searchObject.advancedObject.firstUltimaResposta",
                        placeholder="Selecione",
                        format="dd/MM/yyyy",
                        v-mask="'##/##/#####'"
                      )
                      p.label.span até
                      el-date-picker.input.full-width(
                        type="date",
                        name='lastUltimaResposta'
                        v-model="searchObject.advancedObject.lastUltimaResposta",
                        placeholder="Selecione",
                        format="dd/MM/yyyy",
                        v-mask="'##/##/#####'"
                      )
              el-col.marginTop.toRight
                el-button(
                  v-if="botaoLimpar"
                  type="text"
                  @click="handleLimpar()"
                ) Limpar
                el-button(
                  type="primary"
                  @click="pesquisar()"
                ).marginLeft
                  i.fal.fa-search
                  |&emsp;Pesquisar
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'

const advancedObject = {
  assunto: '',
  status: '',
  firstInicioConversa: '',
  lastInicioConversa: '',
  firstUltimaResposta: '',
  lastUltimaResposta: ''
}

export default {
  props: {
    botaoLimpar: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      tipos: [],
      assuntos: [],
      status: [],
      searchObject: {
        advancedObject: _.cloneDeep(advancedObject)
      }
    }
  },

  methods: {
    ...mapActions({
      getAssunto: 'conversas/getAssuntosOuvidoria',
      getStatus: 'conversas/getStatusOuvidoria'
    }),
    pesquisar () {
      this.$emit('search', this.searchObject.advancedObject)
    },
    handleLimpar () {
      this.$emit('limpar', this.searchObject.advancedObject)
    },
    async findAssunto () {
      this.assuntos = await this.getAssunto()
    },
    async findStatus () {
      this.status = await this.getStatus()
    }
  },

  beforeMount () {
    this.pesquisar()
    this.findAssunto()
    this.findStatus()
  }

}
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/_variables.scss";

  .searchPanel {
    display: flex;
    flex-direction: column;
    text-align: left;

    .full-width {
      width: 100%;
    }
  }
  .span{
    margin: 5px 10px !important;
  }
  .flex{
    display: flex;
    align-items: flex-end;
  }
  .label-option {
    font-family: Arial, Helvetica, sans-serif;
  }
  .marginTop {
    margin-top: 13px;
  }
  .label {
    font-size: 13px;
  }
  .toRight {
    display: flex;
    justify-content: flex-end;
  }
  .marginLeft {
    margin-left: 13px;
  }
  .titulo {
    font-size: 1.5rem;
    padding: 0 0 23px 0;
  }

  @media (max-width: 780px) {
    .boxLabel {
      display: flex;
      flex-direction: column;
    }

    .searchPanel .full-width {
      width: 230px;
    }

    .marginLeft {
      padding-bottom: 20px;
      padding-top: 20px;
    }

    .flex {
      flex-direction: column;
      align-items: start;
    }

    .cardGeral {
        position: relative;
        top: 95px;
        right: 45%;
    }

    .searchPanel {
      height: 680px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/comunicacao/SearchConversas.vue